export default __webpack_public_path__ + "static/media/icon-delete.14a64abb.svg";